module.exports = __webpack_public_path__ + "static/media/puzzle-21-bg.75dbce45.svg";